import React from 'react';

import styles from './Button.module.scss';

interface ButtonProps {
    children: React.ReactNode;
    onClick(): void;
}

const Button = ({ children, onClick }: ButtonProps) => {
    return (
        <button onClick={onClick} className={styles.button}>
            {children}
        </button>
    );
};

export default Button;
